import React from 'react';
import {
  Box,
  Avatar,
  Typography,
  IconButton,
  Collapse,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@mui/material';
import TrainIcon from '@mui/icons-material/Train';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import iconMap from '../../utils/mapIcons';
import { serviceType } from '../../enum/serviceType';

function ServiceGrid({
  services,
  expandedService,
  onToggle,
  subLineMap,
  stops
}) {

  const getServiceCount = (stops, code) => {
    if (stops === undefined)
      return 0

    const serviceCounts = stops.reduce((acc, stop) => {
      const service = stop.route_id;
      acc[service] = (acc[service] || 0) + 1;
      return acc;
    }, {});

    return serviceCounts[code] || 0
  };

  console.log("stop", stops)
  return (
    <Box
      sx={{
        display: 'grid',
        gap: 1,
        gridTemplateColumns: {
          xs: 'repeat(2, 1fr)',
          sm: 'repeat(3, 1fr)',
          md: 'repeat(4, 1fr)',
        },
      }}
    >
      {services.map((service) => {
        const isExpanded = expandedService === service.type;
        const hasSubLines = !!subLineMap[service.type];

        return (
          <Box
            key={service.id}
            sx={{
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              p: 1,
              cursor: hasSubLines ? 'pointer' : 'default',
              width: '100%',
              flex: 'none',
            }}
            onClick={() => hasSubLines && onToggle(service.type)}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
              {hasSubLines ?
                null
                :
                <Avatar
                  sx={{
                    bgcolor: service.color,
                    width: { xs: 24, sm: 32 },
                    height: { xs: 24, sm: 32 },
                    fontSize: { xs: 16, sm: 24 },
                  }}
                >
                  <img
                    src={iconMap[service.type]}
                    alt={service.type}
                    style={{ width: '70%', height: '70%' }}
                  />
                </Avatar>}

              <Box sx={{ ml: 1 }}>
                <Typography
                  fontWeight={600}
                  fontSize={{ xs: 13, sm: 14 }}
                  noWrap
                >
                  {service.type}
                </Typography>
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography
                    fontSize={{ xs: 10, sm: 12 }}
                    color="text.secondary"
                    noWrap
                  >
                    {service.fullName}
                  </Typography>
                  {hasSubLines ?
                    null :
                    <Typography
                      variant="body2"
                      fontWeight="bold"
                      sx={{ fontSize: { xs: 11, sm: 14 } }}
                    >
                      {stops[service.type] ? stops[service.type].length : 0}
                    </Typography>
                  }
                </Box>

              </Box>
              {hasSubLines && (
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    onToggle(service.type);
                  }}
                  aria-label={isExpanded ? 'collapse' : 'expand'}
                  sx={{ ml: 'auto' }}
                >
                  {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              )}
            </Box>

            {hasSubLines && (
              <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                <List disablePadding sx={{ pl: 2 }}>
                  {subLineMap[service.type].map((line, idx) => (
                    <ListItem
                      key={idx}
                      sx={{
                        py: { xs: 0.2, sm: 0.3 },
                        pl: 0,
                      }}
                    >
                      <ListItemAvatar>
                        <Avatar
                          sx={{
                            bgcolor: line.color,
                            width: { xs: 20, sm: 24 },
                            height: { xs: 20, sm: 24 },
                            fontSize: { xs: 12, sm: 14 },
                          }}
                        >
                          <img
                            src={iconMap[service.type === serviceType.LRT ? line.code : line.line]}
                            alt={service.type}
                            style={{ width: '70%', height: '70%' }}
                          />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={line.name}
                        primaryTypographyProps={{
                          fontSize: { xs: 11, sm: 13 },
                        }}
                      />
                      <Typography
                        variant="body2"
                        fontWeight="bold"
                        sx={{ fontSize: { xs: 11, sm: 14 } }}
                      >
                        {console.log("line", line)}
                        {getServiceCount(stops[service.type], service.type === serviceType.LRT ? line.code : line.line)}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            )}
          </Box>
        );
      })}
    </Box>
  );
}

export default ServiceGrid;
